import * as yup from "yup";
import { BaseSchema } from "../../BaseSchema";

export const editClientAccValidation = () => {
  const schema = yup.object().shape({
    client_acc_name: yup.string().label("This field").required().max(200),
    accountAdmins: yup
      .array()
      .min(
        1,
        "Account Admin is mandatory. Please assign at least one Account Admin"
      ),
    supported_lang: yup.array().label("This field"),
    ...BaseSchema,
  });

  return { schema };
};
